export default function setInfoDecimal(num) {
	if (typeof num === 'number' || typeof num === 'string') {
		let n = 0;
		if (typeof num === 'string') {
			n = num.replace(',', '', 'g');
		} else {
			n = num;
		}
		// return n ? (Number(n) / 100).toFixed(2) : 0;
		return num + '积分';
	} else {
		return 0;
	}
}
